import type { ReactElement } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { signOut, type MeUser } from '../../api/admin.js';
import { Icon } from './icons.js';

interface TopbarProps {
  user: MeUser;
  onOpenCmdK: () => void;
}

const ENV_LABEL = import.meta.env.MODE === 'production' ? 'prod' : 'dev';

export function Topbar({ user, onOpenCmdK }: TopbarProps): ReactElement {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  async function onLogout(): Promise<void> {
    await signOut();
    await queryClient.invalidateQueries({ queryKey: ['admin-session'] });
    void navigate('/login', { replace: true });
  }

  const initials = (user.name ?? user.email).slice(0, 2).toUpperCase();

  return (
    <header className="topbar" data-testid="topbar">
      <button
        type="button"
        className="topbar-search"
        onClick={onOpenCmdK}
        data-testid="topbar-search"
      >
        <Icon name="search" className="topbar-search-icon" />
        <span className="topbar-search-text">
          Search by email, session ID, trace ID, provider request ID…
        </span>
        <span className="topbar-search-kbd">
          <span className="kbd">⌘</span>
          <span className="kbd">K</span>
        </span>
      </button>
      <div className="topbar-right">
        <span className={`env-pill ${ENV_LABEL}`}>{ENV_LABEL}</span>
        <button type="button" className="avatar-btn" title={user.email}>
          <span className="avatar">{initials}</span>
          <span className="avatar-btn-email mono">{user.email}</span>
        </button>
        <button
          type="button"
          className="btn ghost"
          onClick={() => void onLogout()}
          data-testid="logout"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
